import React from "react";

import Text from "src/components/text";

import styles from "./dealListItem.module.scss";
import { DealItem } from "src/types/reports";
import { useSelector } from "react-redux";
import _ from "lodash";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface DealListItemProps {
  item: DealItem;
  columnCount: number;
}

const DealListItem: React.FC<DealListItemProps> = ({ item, columnCount }) => {
  const { name, asset, createdDate, stage, amount, id } = item;

   const currency = useSelector((state) =>
      _.get(state, "accounts.item.currency", ""),
    );
  return (
    <div key={id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <Text className={styles.name} text={name} lines={1} />
          </div>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>
          {new Date(createdDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>
       <div className={styles.tableDataShares}>{currency ? `${currency}${amount}` : amount}</div>        <Text text={stage || ""} className={styles.dealsShare} />
        <div className={styles.tableDataShares}>
          <a
            href={`/assets/${asset?.id}?source=reports`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkWrapper}
          >
            <img
              src={asset?.icon?.thumbnail || DefaultAssetIcon}
              alt={asset?.name || "Asset"}
              className={styles.thumbnailIcon}
            />
            <Text text={asset?.name || ""} className={styles.name} lines={1} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DealListItem;
